__turbopack_context__.v({
  "sizeSelect": "styles-module__xr6zcW__sizeSelect",
});
